<script lang="ts" setup></script>

<template>
  <div
    class="max-w-[calc(1448px+(var(--container-padding)*2))] px-[var(--container-padding)] lg:px-0 w-full lg:max-w-[1000px]! mx-auto"
  >
    <slot />
  </div>
</template>
